<template>
  <div class="rezervacije page-view">
    <div class=rezervacije-header>
      <span>{{ this.$store.state.selectedCar.ime_vozila }}</span>
      <span>{{ this.$store.state.selectedCar.registracijska_oznaka }}</span>
    </div>
    <ejs-grid ref='grid' :dataSource="this.$store.state.events" :rowSelected='rowSelected' :rowDeselected='rowDeselected' :allowTextWrap="false">
      <e-columns>
          <e-column headerText='Klijent' :template='KlijentTemplate' textAlign='Left'></e-column>
          <e-column headerText='Pick' :template='PreuzimanjeTemplate' textAlign='Center'></e-column>
          <e-column headerText='Drop' :template='PovratakTemplate' textAlign='Center'></e-column>
          <e-column headerText='Status' :template='StatusTemplate' width=80 textAlign='Center'></e-column>
        </e-columns>
    </ejs-grid>
    <p style="font-size: 0.8rem; text-align: center;">Ukupno zapisa: {{ brojRezervacija }} </p>
    <div  id=event-add-icon v-bind:class="{ transparent: this.isScrolling }" @click="onAdd">
      <img class=custom-icon-shadow src='img/plus.png' width="50" height="50"/>
    </div>
    <div id=row-icons>
      <img class=custom-icon-shadow src='img/edit.png' width="36" height="36" @click="onEdit" v-bind:class="{ hidden: !this.selectedEventID, transparent: this.isScrolling }"/>
      <img class=custom-icon-shadow src='img/remove.png' width="36" height="36" @click="onDeleteClick" v-bind:class="{ hidden: !this.selectedEventID, transparent: this.isScrolling }"/>
    </div>
  </div>
</template>

<style lang="scss"> 
#event-add-icon {
  position: fixed;
  right: 25px;
  bottom: 35px;
  transition: 0.3s ease-out opacity;
}

.rezervacije-header {
  
  width: 100%;
  border-bottom: 1px solid gray;

  span {
    display: block;
    margin-bottom: 5px;
    margin-left: 20px;
  }
  :first-child {
    font-weight: bold;
    font-size: 1.2rem;
  }
  :nth-child(2) {
    font-weight: normal;
    font-size: 0.8rem;
  }
}

.rezervacije-polja-klijent {
  span {
    display: block;
  }
}

.rezervacije-polja-preuzimanje {
  span {
    display: block;
  }
}

.rezervacije-polja-povratak {
  span {
    display: block;
  }
}

.event-status {
  height: 36px;
  width: 36px;
  border-radius: 100%;
  margin: auto;
  p {
      margin: 0;
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 500;
    font-size: 20px;
  }

}

.event-status.status-finish {
  background-color: #cecece;
}

.event-status.status-rent {
  background-color: #ff4400;
}

.event-status.status-reservation {
  background-color: #ffdd00;
}

</style>

<script>
import Vue from 'vue';

export default {
  name: 'event_list',
  data() {
    return {
      isScrolling: false,
      scrollDelay: null,
      selectedEvent: null,
      KlijentTemplate() {
          return { 
            template : Vue.component('KlijentTemplate', {
                        template: `<div class=rezervacije-polja-klijent><span>{{ this.data.clientName}}</span></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        }
                      })
          }
      },
      PreuzimanjeTemplate() {
          return { 
            template : Vue.component('PreuzimanjeTemplate', {
                        template: `<div class=rezervacije-polja-preuzimanje><span>{{ this.data.pickupDate}}</span><span>{{ this.data.pickupTime}}</span><span>{{ this.data.pickupPlace}}</span></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        }
                      })
          }
      },
      PovratakTemplate() {
          return { 
            template : Vue.component('PovratakTemplate', {
                        template: `<div class=rezervacije-polja-povratak><span>{{ this.data.dropDate}}</span><span>{{ this.data.dropTime}}</span><span>{{ this.data.dropPlace}}</span></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        }
                      })
          }
      },
      StatusTemplate() {
          return { 
            template : Vue.component('StatusTemplate', {
                        template: `<div class='event-status' v-bind:class="{ 'status-finish': this.statusFinish, 'status-rent': this.statusRent, 'status-reservation': this.statusReservation }"><p>{{ this.statusText }}</p></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        },
                        computed: {
                          statusText () {
                            if(this.data.eventStatus == '0') return 'Z';  //zavrseno
                            if(this.data.eventStatus == '1') {
                              if(this.data.eventName == '0') return 'N';
                              if(this.data.eventName == '1') return 'R';
                            }
                            return '?';
                          },
                          statusFinish() {
                            if(this.data.eventStatus == '0') return true;
                            return false;
                          },
                          statusRent() {
                            if(this.data.eventStatus == '1' && this.data.eventName == '0') return true;
                            return false;
                          },
                          statusReservation() {
                            if(this.data.eventStatus == '1' && this.data.eventName == '1') return true;
                            return false;
                          }
                        }
                      })
          }
      },
    }
  },
  mounted() {
    this.$store.state.hideReturnIcon = false;
    this.$store.state.hideSettingIcon = false;
    this.$store.state.hideFloatWidgetRight = true;
    this.$store.state.hideCloseIcon = true;
    this.$store.dispatch('getEventForSpecificCar', this.$store.state.selectedCar.ID).catch(err => this.$parent.showNotification(err));
    this.$store.state.currentView = 'rezervacije';
    this.$store.state.previousView = 'flota';
    this.$store.state.viewTitle = 'Rezervacije';
  },
  computed: {
    brojRezervacija() {
      if (this.$store.state.events) {
        if (this.$store.state.events.length) return this.$store.state.events.length;
      }
      return 0;
    },
    selectedEventID() {
      if (this.selectedEvent) return this.selectedEvent.ID;
      else return 0;
    }
  },
  methods: {
    onAdd() {
      this.$store.state.selectedEvent = null;     //clear selected event in store
      this.$router.push('rezervacija');
    },
    onEdit() {
      this.$router.push('rezervacija');
    },
    onDeleteClick() {
      this.$parent.showPopup(this, 'Želite li obrisati zapis za klijenta: ' + this.selectedEvent.clientName);
    },
    async onDelete() {
      await this.$store.dispatch('deleteEvent', { ID : this.selectedEvent.ID, carID: this.selectedEvent.carID }).then(res => this.$parent.showNotification(res)).catch(err => this.$parent.showNotification(err));
      this.$store.dispatch('getEventForSpecificCar', this.$store.state.selectedCar.ID).catch(err => this.$parent.showNotification(err));
    },
    rowSelected(args) {
       this.selectedEvent = args.data;
       this.$store.state.selectedEvent = this.selectedEvent;
    },
    rowDeselected() {
       this.selectedEvent = null;
       this.$store.state.selectedEvent = this.selectedEvent;
    },
    onWindowScroll() {
      this.isScrolling = true;
      clearInterval(this.scrollDelay); 
      this.scrollDelay = setTimeout(()=> {
        this.isScrolling = false;
      }, 100);
    },
  },
  created() {
    //window.addEventListener('scroll', this.onWindowScroll);
  },
  destroyed() {
    //window.removeEventListener('scroll', this.onWindowScroll);
  }
}
</script>